export const environment = {
  production: true,
  dynatraceUrl: 'https://js-cdn.dynatrace.com/jstag/1658b155923/bf07634sen/49d6495ad2a592e0_complete.js',
  baseUrlRedirect: 'https://app.ingood.es',
  baseUrl: 'https://appproxy.ingood.es/helio-rsg',
  baseUrlProxy: '/Account/login',
  proxyURL: 'https://appproxy.ingood.es',
  proxy: true,
  BD: '',
  b2cEnv: '',
  b2c: '',
  adobe: '//assets.adobedtm.com/457d03397210/5f6940736f58/launch-85416c8b67a3.min.js',

  apis: {
    product: "api/product",
    pricing: "api/pricing",
    payment: "api/payment",
    person: "api/person",
    policy: "api/policy"
  },

  //ApiProducto: '/api-product/api',
  //ApiPricing: '/api-pricing/api',
  //ApiNotify: '/api-notify/api',
  //ApiPerson: '/api-person/api',
  //ApiPolicy: '/api-policy/api',
  //ApiBilling: '/api-billing/api',
  //ApiPayment: '/api-payment/api',
  //ApiClaims: '/api-claims/api',

  IDB2C: '2e9e6c99-0eae-46d5-bfe1-8860530cf56f',
  lang: 'es',
  langSource: 'environment',
  idIdioma: 1,
  b2cDomain: "heliorealeseguros",
  logo: "ingood_horizontal_negativa_solana@2x.png",
  app_name: "ingood",
  helioEmail: 'hola@ingood.es',
  allowedFileSize: {
    documents: 1,
    images: 3
  },
  appInsights: {
    connectionString: 'InstrumentationKey=89a0ab3c-8942-40cf-8570-dba762597fa0;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/'
  },
  isCameraRequired: true,
};
